import NonstaticFooterLegal from './NonstaticFooterLegal';
export default NonstaticFooterLegal;